@if (errorMessage()) {
<small class="form-error">
  <i class="bi bi-exclamation-triangle-fill"></i>
  {{ errorMessage() }}
</small>
} @else if (activeErrorKey()) {
<small class="form-error">
  <i class="bi bi-exclamation-triangle-fill"></i>
  {{ activeErrorKey()! | translate }}
</small>
}